var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"min-width":"100%","max-width":"100%","height":"1000px","border":"none"},attrs:{"title":"Renovação e-CPF A3 em Nuvem","onload":"window.parent.scrollTo(0,0)","allowtransparency":"true","allow":"geolocation; microphone; camera; fullscreen","src":"https://form.jotform.com/250296474381058","frameborder":"0","scrolling":"no"}})])
}]

export { render, staticRenderFns }